import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './../LoginStyles.css';
import { Container } from 'react-bootstrap';

function Venezuela() {
  return (
    <Container>
      <div className='container'>
        <div className='card mt-4'>
          <div className='card-body'>
            <h2>Venezuela</h2>
            <p>Is a country on the northern coast of South America,
              consisting of a continental landmass and many islands
              and islets in the Caribbean Sea. Venezuela comprises an
              area of 916,445 km2, and its population to be around
              30 million inhabitants.
            </p>
              The continental territory is bordered on the north by the 
              Caribbean Sea and the Atlantic Ocean, on the west by Colombia, 
              Brazil on the south, Trinidad and Tobago to the north-east 
              and on the east by Guyana. Venezuela is a presidential republic 
              consisting of 23 states, the Capital District and federal 
              dependencies covering Venezuela's offshore islands. Venezuela 
              is among the most urbanized countries in Latin America
            <p>
            </p>
              The current president of the country is Nicolas Maduro Moros.
              He has been in charge of the country since March 2013.
              <br></br>
          </div>
          <div className='ratio ratio-16x9'>
            <iframe width="300" height="200" src="https://www.youtube.com/embed/vXpiqY2U4b8?si=22djRORj5oS4oaVs" title="YouTube video player"
              frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
              referrerpolicy="strict-origin-when-cross-origin" allowFullScreen>
            </iframe>
          </div>
        </div>
      </div>
      <br></br>
    </Container>
  );
}

export default Venezuela;
